/* eslint-disable no-unused-vars */
import { FETCH_PRODUCT_SUMMARY } from './productSummaryActionTypes';

const InitialState = {
    publish: 50,
    total: 100,
    private: 0,
    pendingReview: 10,
    draft: 0,
};

const ProductSummaryReducer = (state = InitialState, { type, payload }) => {
    switch (type) {
        case FETCH_PRODUCT_SUMMARY:
            return {
                ...state,
            };
        default:
            return state;
    }
};

export default ProductSummaryReducer;
